import { IPlanCardV2, IPlanCard, NBN_PRODUCT_STATUS } from '@belong/types';
/**
 *
 * @param plan
 * @returns boolean
 * @description
 * NBN Specific function that takes in a plan and tests the plan status.
 * Mobile plans don't have a status so they will always return true.
 */
export const planStatusFilter = (plan: IPlanCardV2 | IPlanCard): boolean => {
  if (plan.plan?.status && plan.plan.status === NBN_PRODUCT_STATUS.ACTIVE) {
    return true;
  }

  if (plan.plan?.status && plan.plan.status === NBN_PRODUCT_STATUS.INACTIVE) {
    return false;
  }
  return true;
};
